import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../About.css';

const Retail = () => {
  const solutions = ['E-commerce Platforms', 'POS Systems', 'Inventory Management', 'Customer Loyalty Programs', 'Omnichannel Solutions', 'Supply Chain Integration'];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>Retail & E-commerce Solutions</h1>
          <p>Omnichannel retail platforms and inventory management systems</p>
        </div>
      </section>

      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Powering Modern Retail</h2>
            <p>
              We build comprehensive retail solutions that unify online and offline channels, streamline
              operations, and enhance customer experiences. From e-commerce platforms to point-of-sale
              systems, we help retailers compete in the digital age.
            </p>
          </div>
        </div>
      </section>

      <section className="about-expertise">
        <div className="container">
          <div className="section-header"><h2>Retail Solutions</h2></div>
          <div className="expertise-grid">
            {solutions.map((s, i) => <div key={i} className="expertise-item">{s}</div>)}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Transform Your Retail Business</h2>
            <p>Let's discuss your retail technology needs.</p>
            <Link to="/contact">
              <Button variant="contained" size="large" endIcon={<ArrowForwardIcon />}
                sx={{ backgroundColor: '#2271b1', color: '#ffffff', fontWeight: '600', padding: '14px 32px', fontSize: '15px', textTransform: 'none', borderRadius: '3px', boxShadow: '0 1px 0 #135e96', '&:hover': { backgroundColor: '#135e96' } }}>
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Retail;
